import { useTheme } from '../contexts';

interface ThemeColors {
  bgPrimary: string;
  bgSecondary: string;
  bgTertiary: string;
  bgInfo: string;
  bgWarning: string;
  bgSuccess: string;
  bgError: string;
  borderInfo: string;
  borderWarning: string;
  borderSuccess: string;
  borderError: string;
  textPrimary: string;
  textSecondary: string;
  textTertiary: string;
}

export const useThemeColors = (): ThemeColors => {
  const { isDark } = useTheme();

  if (isDark) {
    return {
      bgPrimary: '#141414',
      bgSecondary: '#1f1f1f',
      bgTertiary: '#262626',
      bgInfo: '#111b26',
      bgWarning: '#2d2a1f',
      bgSuccess: '#1f2a1f',
      bgError: '#2a1f1f',
      borderInfo: '#15395b',
      borderWarning: '#594214',
      borderSuccess: '#274916',
      borderError: '#58181c',
      textPrimary: 'rgba(255, 255, 255, 0.85)',
      textSecondary: 'rgba(255, 255, 255, 0.65)',
      textTertiary: 'rgba(255, 255, 255, 0.45)',
    };
  }

  return {
    bgPrimary: '#ffffff',
    bgSecondary: '#fafafa',
    bgTertiary: '#f5f5f5',
    bgInfo: '#e6f7ff',
    bgWarning: '#fffbe6',
    bgSuccess: '#f6ffed',
    bgError: '#fff1f0',
    borderInfo: '#91d5ff',
    borderWarning: '#ffe58f',
    borderSuccess: '#b7eb8f',
    borderError: '#ffa39e',
    textPrimary: 'rgba(0, 0, 0, 0.85)',
    textSecondary: 'rgba(0, 0, 0, 0.65)',
    textTertiary: 'rgba(0, 0, 0, 0.45)',
  };
};
